import Intro from "../components/intro/intro";
import MapUI from "../components/mapUi/mapUi.component";
import MapInfo from "../components/mapUi/info/MapInfo.component";
import Route from "../components/mapUi/route/route.component";
import Navigation from "../components/mapUi/navigation/navigation.component";
import News from "../components/news";
import Events from "../components/events/EventList.component";
import Language from "../components/intro/pages/language/Language.intro";
import Campus from "../components/intro/pages/campus/Campus.intro";
import Location from "../components/intro/pages/location/Location.intro";
import Push from "../components/intro/pages/push/Push.intro";
import Restrictions from "../components/intro/pages/restrictions/Restrictions.intro";
import Complete from "../components/intro/pages/complete/Complete.intro";
import UserGroups from "../components/intro/pages/userGroups/UserGroups.intro";
import HealthStats from "../components/intro/pages/healthStats/HealthStats.intro.jsx";
import Search from "../components/search/search.jsx";
import Phonebook from "../components/phonebook/phonebook.component";
import Settings from "../components/settings/Settings.component";
import Loader from "../components/MissingCampusLoader/MissingCampusLoader";
import ChoosePiKey from "../components/intro/pages/login/ChoosePiKey.page";
import WelcomPage from "../components/intro/pages/login/Welcom.page";

const routes = [
  {
    path: "/intro",
    component: Intro,
    routes: [
      {
        path: "/intro/login",
        component: WelcomPage,
      },
      {
        path: "/intro/choose-piKey",
        component: ChoosePiKey,
      },
      {
        path: "/intro/select-language",
        component: Language,
      },
      {
        path: "/intro/select-campus",
        component: Campus,
      },
      {
        path: "/intro/select-location",
        component: Location,
      },
      {
        path: "/intro/select-healthstats",
        component: HealthStats,
      },
      {
        path: "/intro/select-push",
        component: Push,
      },
      {
        path: "/intro/select-restrictions",
        component: Restrictions,
      },
      {
        path: "/intro/select-user-group",
        component: UserGroups,
      },
      {
        path: "/intro/complete",
        component: Complete,
      },
    ],
  },
  {
    path: "/map",
    component: MapUI,
    routes: [
      {
        path: "/map/info",
        component: MapInfo,
      },
      {
        path: "/map/route",
        component: Route,
      },
      {
        path: "/map/navigation",
        component: Navigation,
      },
    ],
  },
  {
    path: "/news",
    component: News,
  },
  {
    path: "/events",
    component: Events,
  },
  {
    path: "/phonebook",
    component: Phonebook,
  },
  {
    path: "/search/:piKey",
    component: Search,
  },
  {
    path: "/settings",
    component: Settings,
  },
  {
    path: "/loader",
    component: Loader,
  },
];

export default routes;
